import React, { useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomSelectField = ({
  options = [],
  color,
  fontWeight,
  getOptionLabel = (option) => option?.label || option,
  getOptionValue = (option) => option?.value || option,
  error,
  helperText,
  borderColor,
  fontSize,
  dafualtValue,
  width,
  ExpandMoreIconColor,
  texFieldWidth,
  borderRadius,
  boxShadow,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  return (
    <TextField
      select
      variant="outlined"
      size="small"
      SelectProps={{
        open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        displayEmpty: true,
        IconComponent: () => (
          <ExpandMoreIcon
            style={{
              cursor: "pointer",
              color: ExpandMoreIconColor ? ExpandMoreIconColor : "#000000",
              marginRight: "10px",
            }}
            onClick={(e) => {
              e.stopPropagation(); // stop event from bubbling
              setOpen((prev) => !prev);
            }}
          />
        ),
        renderValue: (selected) => {
          if (!selected) {
            return (
              <span
                style={{
                  color: "#888888",
                  fontFamily: "Inter",
                  fontSize: "13px",
                  fontWeight: 400,
                }}
              >
                {dafualtValue}
              </span>
            ); // placeholder-like
          }
          const selectedOption = options.find(
            (option) => getOptionValue(option) === selected
          );
          return getOptionLabel(selectedOption) || selected;
        },
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 200, // control dropdown height
              width: width ? width : 300, // control dropdown width
            },
          },
        },
      }}
      sx={{
        width: texFieldWidth,
        backgroundColor: "#FFFFFF !important",
        borderRadius: borderRadius ? borderRadius : "4px",

        "& .MuiOutlinedInput-root": {
          backgroundColor: "#FFFFFF",
          borderRadius: borderRadius ? borderRadius : "4px",
          borderColor: borderColor ? borderColor : "#E0E0E0",
          boxShadow: boxShadow
            ? "0px 2px 4px 0px rgba(200, 141, 235, 0.25)"
            : "",
          "& fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            transition: "border-color 0.3s ease",
          },
          "&:hover fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
          },
          "&.Mui-focused fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            borderWidth: "1px",
          },
        },
        "& .MuiSelect-select": {
          backgroundColor: "#FFFFFF",
          padding: "10px 12px",
          fontSize: fontSize ? fontSize : "15px",
          color: color ? color : "#000000",
          borderRadius: borderRadius ? borderRadius : "4px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },
        "& .MuiInputBase-root": {
          height: 36, // ⬅️ decrease field height
          minHeight: 36,
        },
        "& .MuiSelect-select": {
          backgroundColor: "#FFFFFF",
          padding: "6px 12px", // ⬅️ less padding = smaller height
          fontSize: fontSize ? fontSize : "15px",
          color: color ? color : "#000000",
          borderRadius: borderRadius ? borderRadius : "4px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },
        ...props.sx,
      }}
      error={error}
      helperText={helperText}
      {...props}
    >
      {options?.map((option, index) => (
        <MenuItem key={index} value={getOptionValue(option)}>
          {getOptionLabel(option)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CustomSelectField;
